import React from 'react';

const Loadable = React.lazy(() => import('../../pages/CEO/CEO'));

export default Loadable;
